import * as React from "react";
import {
    Avatar,
    Dialog,
    DialogTitle,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from "@material-ui/core";
import {DeleteAccountRequest, SNSDataList} from "../../util/api";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

type AccountListDialogProps = {
    isOpen: boolean;
    setOpen: (open: boolean) => void;
    setAddAccountOpen: (open: boolean) => void;
    setDeleteAccountOpen: (open: boolean) => void;
    setDeleteAccountRequest: (a: DeleteAccountRequest) => void;
    list: SNSDataList;
};

export const AccountListDialog: React.FC<AccountListDialogProps> = (
    props: AccountListDialogProps
) => {
    const {
        isOpen,
        setOpen,
        setAddAccountOpen,
        setDeleteAccountOpen,
        setDeleteAccountRequest,
        list,
    } = props;

    const handleClose = () => {
        setOpen(false);
    };
    let key = 1;

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="accountList"
            open={isOpen}
        >
            <DialogTitle id="accountList">アカウント一覧</DialogTitle>
            <List>
                {list &&
                    list.accounts &&
                    list.accounts.length > 0 &&
                    list.accounts.map((account) => (
                        <ListItem key={key++}>
                            <ListItemAvatar>
                                <Avatar
                                    src={account.imageUrl}
                                    alt={account.name}
                                />
                            </ListItemAvatar>
                            <ListItemText primary={account.name} />
                            <IconButton
                                aria-label="delete"
                                onClick={() => {
                                    setDeleteAccountRequest({
                                        id: account.id,
                                        serviceType: account.serviceType,
                                    });
                                    setDeleteAccountOpen(true);
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </ListItem>
                    ))}
                <ListItem
                    autoFocus
                    button
                    onClick={() => {
                        setOpen(false);
                        setAddAccountOpen(true);
                    }}
                >
                    <ListItemAvatar>
                        <Avatar>
                            <AddIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="アカウントを追加" />
                </ListItem>
            </List>
        </Dialog>
    );
};
